"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _spacing = _interopRequireDefault(require("../../../../theme/shared/spacing"));
const FundraisingRegulatorWrapper = _styledComponents.default.div.withConfig({
  displayName: "FundraisingRegulatorLogo__FundraisingRegulatorWrapper",
  componentId: "sc-1ngdz4u-0"
})(["width:75%;margin:", " 0;max-width:200px;img{display:block;}"], (0, _spacing.default)('lg'));
const FundraisingRegulatorLogo = () => /*#__PURE__*/_react.default.createElement(FundraisingRegulatorWrapper, null, /*#__PURE__*/_react.default.createElement("a", {
  href: "https://www.fundraisingregulator.org.uk/validate?registrant=COMIC+RELIEF",
  className: "fr-digital-badge",
  style: {
    height: 'auto',
    width: '150px',
    textDecoration: 'none'
  },
  target: "_blank"
}, /*#__PURE__*/_react.default.createElement("img", {
  src: "https://www.fundraisingregulator.org.uk/fr-badge/80983ed7-ea80-40db-8e52-4a3351d9e77d/en/white",
  width: "100%",
  alt: "Fundraising Regulator badge with validation link",
  loading: "lazy"
})));
var _default = exports.default = FundraisingRegulatorLogo;